/* global appData, $ */

import indexPage from '../utils/indexPage';
import hideLoading from '../utils/hideLoading';
import fireEvent from '../utils/fireEvent';
import { setTitle, changeColorAndIcon, shakeIcon } from '../utils/modifyHeaderIcon';

function submitForm($form, googleRecaptchaToken) {
	if (!$form.valid) {
		hideLoading(indexPage.$indexFormBtn);
		return false;
	}

	const createAcctData = {
		firstName: indexPage.$firstName.val(),
		lastName: indexPage.$lastName.val(),
		email: indexPage.$email.val(),
		password: indexPage.$password.val(),
		agreeToTerms: indexPage.$terms.is(':checked'),
		subscribeToMarketingEmails: indexPage.$marketingEmails.is(':checked'),
		googleRecaptchaToken
	};

	const returnUrl = $('#returnUrl').val();

	$.ajax({
		type: 'POST',
		url: `${appData.appPath}`,
		data: createAcctData,
		dataType: 'json',
		success(data) {
			switch (data.status) {
				case 'USER_CREATED': {
					fireEvent('signup succeed');
					window.location.replace(returnUrl);
					break;
				}
				default:
					hideLoading(indexPage.$indexFormBtn);
					break;
			}
		},
		error(data) {
			hideLoading(indexPage.$indexFormBtn);
			if (!data.responseJSON) {
				setTitle('serverError');
			} else {
				switch (data.responseJSON.error) {
					case 'INVALID_INPUT': {
						switch (data.responseJSON.errors[0]) {
							case 'Invalid first name': {
								setTitle('invalidFirstName');
								indexPage.$headerState.focus();
								indexPage.$firstNameLabel.removeClass('success').addClass('error');
								indexPage.$firstName.removeClass('success').addClass('error');
								break;
							}
							case 'Invalid last name': {
								setTitle('invalidLastName');
								indexPage.$headerState.focus();
								indexPage.$lastNameLabel.removeClass('success').addClass('error');
								indexPage.$lastName.removeClass('success').addClass('error');
								break;
							}
							case 'Invalid email address': {
								setTitle('invalidEmail');
								indexPage.$headerState.focus();
								indexPage.$emailLabel.removeClass('success').addClass('error');
								indexPage.$email.removeClass('success').addClass('error');
								break;
							}
							default:
								break;
						}
						break;
					}
					case 'EMAIL_EXISTS': {
						fireEvent('emailexists');
						setTitle('emailExists');
						indexPage.$headerState.focus();
						indexPage.$emailLabel.removeClass('success').addClass('error');
						indexPage.$email.removeClass('success').addClass('error');
						break;
					}
					case 'BLACKLISTED_EMAIL': {
						setTitle('blacklistedEmail');
						indexPage.$headerState.focus();
						indexPage.$emailLabel.removeClass('success').addClass('error');
						indexPage.$email.removeClass('success').addClass('error');
						break;
					}
					case 'NO_USER_CREATED': {
						setTitle('serverError');
						break;
					}
					case 'BOT': {
						setTitle('serverError');
						break;
					}
					default: {
						setTitle('serverError');
						break;
					}
				}
			}
			changeColorAndIcon('red', 'person');
			shakeIcon();
		}
	});
}

export default submitForm;
